import strokeLogoLoop from "@/assets/stroke_logo_loop.svg";
import { cn } from "@/lib/utils";

/** Matches root `<svg width height>` in `stroke_logo_loop.svg` — reserves layout before decode (CLS). */
const STROKE_LOGO_INTRINSIC = { width: 1024, height: 768 } as const;

type LoadingLogoProps = {
  label?: string;
  className?: string;
  logoClassName?: string;
};

export const LoadingLogo = ({
  label = "Loading...",
  className,
  logoClassName,
}: LoadingLogoProps) => {
  return (
    <div className={cn("flex flex-col items-center justify-center py-10", className)}>
      <img
        src={strokeLogoLoop}
        alt="Kryajet loading logo"
        width={STROKE_LOGO_INTRINSIC.width}
        height={STROKE_LOGO_INTRINSIC.height}
        decoding="async"
        className={cn("h-28 w-auto max-w-[420px] object-contain", logoClassName)}
      />
      <p className="mt-3 text-sm text-muted-foreground">{label}</p>
    </div>
  );
};
